import React from "react";

const buildSmoothPath = (coords) => {
  if (coords.length <= 1) {
    return "";
  }

  return coords.reduce((path, point, index, array) => {
    if (index === 0) {
      return `M ${point.x} ${point.y}`;
    }

    const previous = array[index - 1];
    const controlX = (previous.x + point.x) / 2;

    return `${path} C ${controlX} ${previous.y}, ${controlX} ${point.y}, ${point.x} ${point.y}`;
  }, "");
};

const AnalyticsMiniLineChart = ({
  points,
  labels = [],
  showAllLabels = false,
  stroke = "#F6B45E",
  fill = "#FDF0DC",
}) => {
  const width = 320;
  const height = 200;
  const paddingX = 12;
  const paddingY = 14;
  const labelAreaHeight = 24;
  const chartBottomY = height - paddingY - labelAreaHeight;
  const maxPoint = Math.max(...points);
  const minPoint = Math.min(...points);
  const range = Math.max(1, maxPoint - minPoint);
  const stepX = (width - paddingX * 2) / (points.length - 1);

  const coords = points.map((point, index) => {
    const x = paddingX + index * stepX;
    const y = paddingY + (chartBottomY - paddingY) * (1 - (point - minPoint) / range);

    return { x, y };
  });

  const linePath = buildSmoothPath(coords);

  const areaPath = `${linePath} L ${width - paddingX} ${chartBottomY} L ${paddingX} ${chartBottomY} Z`;

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="h-[200px] w-full">
      <defs>
        <linearGradient id="analytics-line-fill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={fill} stopOpacity="1" />
          <stop offset="100%" stopColor={fill} stopOpacity="0.28" />
        </linearGradient>
      </defs>

      <path d={areaPath} fill="url(#analytics-line-fill)" />
      <path d={linePath} fill="none" stroke={stroke} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />

      {coords.map((point, index) => (
        <circle key={`${point.x}-${index}`} cx={point.x} cy={point.y} r="4" fill={stroke} />
      ))}

      {showAllLabels
        ? coords.map((point, index) => {
            const label = labels[index] ?? labels[index % Math.max(labels.length, 1)] ?? "";

            return (
              <text
                key={`label-${point.x}-${index}`}
                x={point.x}
                y={height - 6}
                textAnchor="middle"
                className="fill-[#9CA3AF] text-[11px] font-['Inter']"
              >
                {label}
              </text>
            );
          })
        : null}
    </svg>
  );
};

export default AnalyticsMiniLineChart;
